import { render } from "./OCRConfigForm.vue?vue&type=template&id=1aec028d&scoped=true&ts=true"
import script from "./OCRConfigForm.vue?vue&type=script&lang=ts"
export * from "./OCRConfigForm.vue?vue&type=script&lang=ts"

import "./OCRConfigForm.vue?vue&type=style&index=0&id=1aec028d&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aec028d"]])

export default __exports__